// extracted by mini-css-extract-plugin
export var contentBlock = "HistoryPage-module--contentBlock--sgBuP";
export var historyPage = "HistoryPage-module--historyPage--GZle9";
export var image = "HistoryPage-module--image--TKfQS";
export var imageToRight = "HistoryPage-module--imageToRight--7shL9";
export var noTitle = "HistoryPage-module--noTitle--Ju4bX";
export var text = "HistoryPage-module--text--5D4Gq";
export var withSeparator = "HistoryPage-module--withSeparator--vi+sk";